import {
  SRC_ERROR,
  DES_ERROR,
  SRC_DES_SAME_ERROR,
  DEP_ERROR,
  ARR_ERROR,
  SRC_DES_EMPTY_ERROR
} from '@stencil/flights-constants/src/error-message';
import { ROUNDTRIP_JOURNEY_TYPE } from '@stencil/flights-constants/src/text';

const checkErrorSearchWidget = (flightSearchData, cityCountrySearchWidget = false) => {
  const { source, destination, departure, arrival, journeyType } = flightSearchData;

  if (!source) {
    return SRC_ERROR;
  }
  if (!destination) {
    return DES_ERROR;
  }
  if (source && destination && !source.iata && !destination.iata) {
    return SRC_DES_EMPTY_ERROR;
  }
  if (source.iata === destination.iata) {
    return SRC_DES_SAME_ERROR;
  }
  if (!cityCountrySearchWidget && !departure) {
    return DEP_ERROR;
  }
  if (!cityCountrySearchWidget && !arrival && journeyType === ROUNDTRIP_JOURNEY_TYPE) {
    return ARR_ERROR;
  }
  if (source && !source.iata) {
    return SRC_ERROR;
  }
  if (!cityCountrySearchWidget && destination && !destination.iata) {
    return DES_ERROR;
  }
};

export default checkErrorSearchWidget;
